import { createEmbedBlockMarkdownAdapterMatcher } from '@blocksuite/hive-block-embed';
import { BookmarkBlockSchema } from '@blocksuite/hive-model';
import { BlockMarkdownAdapterExtension } from '@blocksuite/hive-shared/adapters';

export const bookmarkBlockMarkdownAdapterMatcher =
  createEmbedBlockMarkdownAdapterMatcher(BookmarkBlockSchema.model.flavour);

export const BookmarkBlockMarkdownAdapterExtension =
  BlockMarkdownAdapterExtension(bookmarkBlockMarkdownAdapterMatcher);
